import microuniversoApi from "app/api/microuniversoApi";
import { useAppSelector } from "app/redux/hooks";
import { RespostaLimiteCredito, RespostaListarHistoricoLimiteCredito } from "app/types/cliente/RespostaLimiteCredito";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container";
import { LimiteCredito } from "./LimiteCredito";

export type LimiteCreditoContainerProps = {
    codigoCliente: number
    onVoltar: () => void;
    passos: Dict<string, () => void>;
    onRemover: () => boolean
};

export const LimiteCreditoContainer = (props: LimiteCreditoContainerProps) => {
    const orcamento = useAppSelector((store) => store.orcamento);

    const [limiteCreditoDados, setLimiteCreditoDados] = useState<RespostaLimiteCredito>();
    const [historicoLimiteCreditos, setHistoricoLimiteCreditos] = useState<RespostaListarHistoricoLimiteCredito>();

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))
    
    const buscarDadosLimiteCredito = async () => {
        globalMU.blockUI();
        try {
            setLimiteCreditoDados(await microuniversoApi.Cliente.LimiteCredito(
                {
                    TamanhoPagina: 20,
                    NumeroPagina: 1,
                    CodigoCliente: props.codigoCliente,
                }
            ));
            globalMU.unblockUI();
        }
        catch (erro) {
            tratamentoErroPadrao(erro);
            globalMU.unblockUI();
        }
    }
    const buscarDadosHistoricoLimiteCredito = async (numeroPagina?: number) => {
        globalMU.blockUI();
        try {
            setHistoricoLimiteCreditos(await microuniversoApi.Cliente.ListarHistoricoLimiteCredito(
                {
                    TamanhoPagina: 20,
                    NumeroPagina: numeroPagina ?? 1,
                    CodigoCliente: props.codigoCliente, 
                }
            ));
            globalMU.unblockUI();
        }
        catch (erro) {
            tratamentoErroPadrao(erro);
            globalMU.unblockUI();
        }

    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    useEffect(() => { 
        passosInterno.current.set("Limite de Credito", () => { })
        buscarDadosLimiteCredito(); 
    }, [])

    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                id="LimiteCreditoContainer"
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
            />

            <LimiteCredito
                cpfCnpj={orcamento.Cliente.CpfCnpj}
                nome={orcamento.Cliente.Nome}
                limiteAtual={limiteCreditoDados?.Limite}
                tipoLimiteAtual={limiteCreditoDados?.TipoCredito}
                dadosLimiteCredito={historicoLimiteCreditos}
                onAlterarListaSelecionada={(numeroPagina: number) => buscarDadosHistoricoLimiteCredito(numeroPagina)}
                onHistorico={() => buscarDadosHistoricoLimiteCredito()}
            />
        </>);
}